<template>
  <!--  메인 배너 영역  -->
  <div class="visual-wrap elect_pay_bg">
    <div class="container">
      <div class="visual_submain">
        <div class="row">
          <!-- 전자결제 -->
          <div class="visual_submain_wrap">
            <div class="visual_submain_txt">
              <h3 class="rp_blue">PC/모바일 어디서나<br>통합 전자결제 서비스</h3>
              <span>쇼핑몰에서 사용 되는 온라인 결제 서비스로<br>안전하고 빠르게 결제를 할 수 있습니다.</span>
            </div>
            <div class="visual_submain_img">
              <img src="/assets/image/main_elect_pay.svg" alt="서비스소개_전자결제">
            </div>
          </div>
          <!-- //전자결제 -->
        </div>
      </div>
    </div>
  </div>
  <!--  //메인 배너 영역   -->
  <!--  메인 컨텐츠 영역  -->
  <section class="main-content-wrap">
    <!--  전자결제   -->
    <div class="main-content-box">
      <div class="container">
        <div class="row">
          <div class="pay_conent_box">
            <h4>전자결제</h4>
            <p class="pc_480">
              립페이페이먼츠의 전자결제는 온/오프라인에서 상품과 서비스를 판매하고<br>
              그 대금을 신용카드, 계좌이체, 모바일 결제 등 다양한 결제수단으로 편리하게 이용할 수 있는 서비스입니다.
            </p>
            <p class="m_480">
              립페이페이먼츠의 전자결제는 온/오프라인에서 상품과 서비스를 판매하고 그 대금을 신용카드, 계좌이체, 모바일 결제 등 다양한 결제수단으로 편리하게 이용할 수 있는 서비스입니다.
            </p>
            <div class="pay">
              <ul>
                <li>
                  <figure>
                    <img src="/assets/image/elec01.svg" alt="다양한 결제 방식">
                  </figure>
                  <strong class="rp_mint">다양한 결제 방식</strong>
                  <em class="pc">실시간 계좌이체, 가상계좌 이체, 휴대폰 결제 등의<br>다양한 결제 방식을 제공합니다.</em>
                  <em class="m">실시간 계좌이체, 가상계좌 이체, 휴대폰 결제 등의 다양한 결제 방식을 제공합니다.</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/elec02.svg" alt="디바이스 최적화">
                  </figure>
                  <strong class="rp_mint">디바이스 최적화</strong>
                  <em>PC, 태블릿, 핸드폰 등 다양한 디바이스에서<br>최적화된 결제 UI 및 안정적인 결제 시스템을 제공합니다.</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/elec03.svg" alt="신용카드 해택">
                  </figure>
                  <strong class="rp_mint">신용카드 혜택</strong>
                  <em>국내 모든 카드사와 해외 주요 카드사를 지원합니다.<br>카드사 무이자 혜택 등 다양한 프로모션을 제공합니다.</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/elec04.svg" alt="낮은 수수료, 유지비 0원">
                  </figure>
                  <strong class="rp_mint">낮은 수수료,유지비 0원</strong>
                  <em>별도의 유지비 없이 낮은 수수료로<br>결제 서비스를 누릴 수 있습니다.</em>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="conent-box-bg"></div>
    </div>
    <!--  //전자결제   -->
  </section>
  <!--  //메인 컨텐츠 영역  -->
  <!--   실제결제화면 (준비중)
  <section class="main_service_wrap">
      <div class="container">
          <div class="row">
              <div class="service_tit">
                  <h5>실제 결제 화면</h5>
                  <p>PC, 핸드폰 어디서나 결제가 쉬워집니다.</p>
              </div>
              <div class="service_view">
                  <figure>
                      <img src="../assets/image/elec_view.svg" alt="실제 전자 결제 화면">
                  </figure>
              </div>
          </div>
      </div>
  </section>
  -->
  <!--   //실제결제화면   -->
  <!--  립페이 페이먼츠 결제  -->
  <section class="pay_service">
    <div class="container">
      <div class="row">
        <div class="pay_service_list">
          <h6 class="rp_mint">립페이 페이먼츠 결제</h6>
          <ul class="pay_service_btn">
            <li><a href="/service/electronic_payment">전자결제</a></li>
            <li><a href="/service/hand_payment">수기결제</a></li>
            <li><a href="/service/sms_payment">SMS결제</a></li>
            <li><a href="/service/regular_payment">정기결제</a></li>
          </ul>
        </div>

      </div>
    </div>

  </section>
  <!--  //립페이 페이먼츠 결제  -->
</template>

<script>
export default {
  name: "ElectronicPaymentView"
}
</script>

<style scoped>

</style>